import {
  Box,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import { useController } from 'react-hook-form';
import { customTheme } from '../../theme';
import { CustomisationOption } from '../../types/customisation';
import { getPriceWithCurrency } from '../../utils/charges';
import { RadioOptionProps } from './types';
import { useState } from 'react';

export function RadioOptions(props: RadioOptionProps) {
  const controller = useController({ name: props.name });
  const { field } = controller;
  const { options, itemCount, type } = props;
  let error = field.value ? false : props.error;
  const [hasError, setHasError] = useState(false);
  let helperText = props.helperText;
  const handleRadioChange = () => {
    error = false;
    helperText = '';
  };

  const isSingleSelect = type === 'singleSelect';
  const noOptionSelected = isSingleSelect && !field.value;

  if (error && !hasError) {
    setHasError(true);
  }
  const showHelperText = hasError && type === 'singleSelect';
  const backgroundColor = noOptionSelected ? '#954104ff' : '#03845bff';

  return (
    <RadioGroup {...field}>
      {showHelperText && (
        <Typography variant="helperText" color={backgroundColor}>
          {helperText}
        </Typography>
      )}
      {options.map((option: CustomisationOption, index) => (
        <Box key={option._id}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 2,
              px: 1,
            }}
          >
            <Box sx={{ display: 'flex', flexGrow: 1 }}>
              <Typography variant="optionName">{option.name}</Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              {option.price !== 0 && (
                <Typography variant="body1" sx={{ whiteSpace: 'nowrap' }}>
                  {getPriceWithCurrency(option.markupPrice)}
                  {field.value === option._id && itemCount > 1 && (
                    <span style={{ marginLeft: 4 }}>(×{itemCount})</span>
                  )}
                </Typography>
              )}
            </Box>
            <Radio
              value={option._id}
              sx={{
                color: error ? '#d4cfcfff' : 'black',
                padding: 0,
                ml: 1.5,
                alignSelf: 'start',
                '&.Mui-checked': {
                  color: 'black',
                },
              }}
              onChange={() => field.onChange(handleRadioChange())}
            />
          </Box>
          {index !== options.length - 1 && (
            <Divider sx={{ borderColor: '#e9e4e4ff' }} />
          )}
        </Box>
      ))}
    </RadioGroup>
  );
}
